import React from 'react';
import './SiriSpinner.css';

const SiriSpinner = ({ size = 'medium', text = null }) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
    xlarge: 'w-24 h-24'
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div className={`buildpilot-spinner ${sizeClasses[size]}`}></div>
      {text && (
        <p className="text-sm text-gray-600 font-medium animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
};

export default SiriSpinner;
